import { configureStore } from '@reduxjs/toolkit';
import uiReducer from '../features/uiSlice';
import authReducer from '../features/authSlice';
import { materialsApi } from '../services/materialsApi';
import { bookmarksApi } from '../services/bookmarksApi';
import { historyApi } from '../services/historyApi';

export const store = configureStore({
  reducer: {
    ui: uiReducer,
    auth: authReducer,
    [materialsApi.reducerPath]: materialsApi.reducer,
    [bookmarksApi.reducerPath]: bookmarksApi.reducer,
    [historyApi.reducerPath]: historyApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(materialsApi.middleware)
      .concat(bookmarksApi.middleware)
      .concat(historyApi.middleware),
});

export default store;
